export default __webpack_public_path__ + "static/media/agregarRole.26aaacb5.png";